import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import style from './style.js'

const PlaceholderLoader = ({ classes }) => {
  return <div className={classes.placeholderLoader} />
}

export default withStyles(style)(PlaceholderLoader)
